<template>
  <div id="search">
    <SearchEngine ></SearchEngine>
  </div>
</template>

<script>
import SearchEngine from "@/components/SearchEngine";

export default {
  name: "search",
  props: {
    loginKey: {
        type: String,
        default: null
    },
    points: {
        type: String,
        default: null
    },
    preferredCabin: {
      type: String,
      default: "Economy"
    },
    adults: {
      type: String,
      default: "1"
    },
    youngAdults: {
      type: String,
      default: "0"
    },
    children: {
      type: String,
      default: "0"
    },
    infants: {
      type: String,
      default: "0"
    },
    // Airport code eg: CPT
    departureAirport: {
      type: String,
      default: null
    },
    arrivalAirport: {
      type: String,
      default: null
    },
    // dates can be any format
    departureDate: {
      type: String,
      default: null
    },
    returnDate: {
      type: String,
      default: null
    },
    // return, multi, oneway
    tripType: {
      type: String,
      default: "return"
    },
    multi1_departureAirport: {
      type: String,
      default: null
    },
    multi1_arrivalAirport: {
      type: String,
      default: null
    },
    multi1_departureDate: {
      type: String,
      default: null
    },
    multi2_departureAirport: {
      type: String,
      default: null
    },
    multi2_arrivalAirport: {
      type: String,
      default: null
    },
    multi2_departureDate: {
      type: String,
      default: null
    },
    multi3_departureAirport: {
      type: String,
      default: null
    },
    multi3_arrivalAirport: {
      type: String,
      default: null
    },
    multi3_departureDate: {
      type: String,
      default: null
    }
  },
  methods: {
    setUrlSearchParameters() {
      this.$store.commit("setUrlSearchParameters", {
        departureDate: this.departureDate,
        departureAirport: this.departureAirport,
        arrivalAirport: this.arrivalAirport,
        preferredCabin: this.preferredCabin,
        adults: this.adults,
        youngAdults: this.youngAdults,
        children: this.children,
        infants: this.infants,
        returnDate: this.returnDate,
        tripType: this.tripType,
        multi1_departureDate: this.multi1_departureDate,
        multi1_departureAirport: this.multi1_departureAirport,
        multi1_arrivalAirport: this.multi1_arrivalAirport,
        multi2_departureDate: this.multi2_departureDate,
        multi2_departureAirport: this.multi2_departureAirport,
        multi2_arrivalAirport: this.multi2_arrivalAirport,
        multi3_departureDate: this.multi3_departureDate,
        multi3_departureAirport: this.multi3_departureAirport,
        multi3_arrivalAirport: this.multi3_arrivalAirport
      });
    }
  },
  mounted() {
    // if (this.points) {
    //   this.$store.commit('setPoints', this.points);
    // }
    this.$store.commit('checkLoginKey', this.loginKey);
    if (this.departureDate) {
      this.setUrlSearchParameters();
    }
  },
  created() {},
  components: {
    SearchEngine
  }
};
</script>


<style lang="scss" scoped>
@import "../assets/styles/settings.scss";

#search {
  //background-color: #f6f6f4;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; 
  padding: 32px 32px 168px 32px;
}

@media (max-width: 375px) {
  #search {
    padding: 16px 16px 32px 16px;
  }
}

</style>